import { useEffect, useState } from "react";
import { getLehrveranstaltungen, getWorkshops } from "../services/cdn.services";
import "./lehre.page.css";
import { LehrveranstraltungenType } from "../types/lehrveranstraltungen.type";
import { WorkshopType } from "../types/workshop.type";
import LanguageButton from "../components/languageButton.component";

function Lehre(
    props: Readonly<{
        isEnglish: boolean;
        setIsEnglish: (newValue: boolean) => void;
    }>
) {
    const { isEnglish, setIsEnglish } = props;

    //Fetch expertise data
    useEffect(() => {
        const fetchData = async () => {
            setLehrveranstraltungenData(await getLehrveranstaltungen());
            setWorkshopData(await getWorkshops());
        };
        fetchData();
    }, [])
    const [lehrveranstraltungenData, setLehrveranstraltungenData] = useState<LehrveranstraltungenType[] | undefined>(undefined);
    const [workshopData, setWorkshopData] = useState<WorkshopType[] | undefined>(undefined);

    const [showElements, setShowElements] = useState<number>(0);
    useEffect(() => {
        if (showElements === workshopData?.length) {
            return;
        }

        const timeout = setTimeout(() => {
            setShowElements(showElements + 1);
        }, 50);

        return () => clearTimeout(timeout);
    }, [showElements]);
    
    return (
        <div id="lehre" className="standard-page">

            <div className="flex gap w-100 between items-center mt-5">
                <div className="remove-on-phone" style={{width: 60}} />
                <h5>{isEnglish ? "Courses including" : "Lehrveranstaltungen u.a."}</h5>
                <LanguageButton onToggle={() => setIsEnglish(!isEnglish)} isEnglish={isEnglish} />
            </div>
            
            <div className="top-lehre-container" >
                {lehrveranstraltungenData?.map((item: LehrveranstraltungenType, index: number) => (
                    <>
                        <div className={`box`}>
                            <p key={index}>{isEnglish ? item.en_titel : item.titel}</p>
                        </div>
                    </>
                ))}
            </div>

            <h5 className="mt-4">{isEnglish ? "Workshops including" : "Workshops u.a."}</h5>

            <div className="flex column items-center">

                <div className="lehre-container">
                    {
                        workshopData?.sort((a, b) => b.datum.localeCompare(a.datum))
                            .map((value: WorkshopType, index: number) => {

                                return <div className={`${showElements <= index ? "invisible-item" : "visible-item"}`} key={index}>
                                    <div className="flex gap mb-2">
                                        <p>{value.datum?.substring(0, 4)}</p>
                                        <p>{isEnglish ? value.en_beschreibung : value.beschreibung}</p>
                                    </div>
                                </div>
                            })
                    }
                </div>
            </div>
        </div>
    );
}

export default Lehre;